import { render, staticRenderFns } from "./editPhotos.vue?vue&type=template&id=c51468ce&scoped=true&lang=pug"
import script from "./editPhotos.vue?vue&type=script&lang=js"
export * from "./editPhotos.vue?vue&type=script&lang=js"
import style0 from "./editPhotos.vue?vue&type=style&index=0&id=c51468ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c51468ce",
  null
  
)

export default component.exports